import styled from 'styled-components';

export const MetricTextStyle = styled.div`
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
`;
